module.exports = __webpack_public_path__ + "img/top2.c36acd2a.png";